export const data={
    experience:[
        {
            title:"Data Science Intern",
            at:"CodSoft",
            desc:"Worked on different tasks and performed EDA on many datasets",
            time:"May 2024 - June 2024",
        },
        {
            title:"AI Intern",
            at:"YHills EduTech",
            desc:"It is a training internship where I have learnt working with different datasets and fitting models",
            time:"May 2023 - July 2023",

        },
        {
            title:"Python Intern",
            at:"InternPe",
            desc:"A training internship which taught working with different libraries in python like tkinter",
            time:"April 2023 - May 2023",
        }
       
    ],
    education:[
        {
            title:"B.Tech",
            at:"Vignan's Institute of Information Technology,Duvvada",
            desc:"Undergraduate in the branch of Computer Science",
            time:"2021 - Present",
        },
        {
            title:"Intermediate",
            at:"Sri Chaitanya Jr College,NAD",
            desc:"Under AP Board (MPC) and secured 975/1000 ",
            time:"2019 - 2021",
        },
        {
            title:"SSC",
            at:"Sri Chaitanya School,Pendurthi",
            desc:"Under AP SSC Board and secured GPA : 10/10",
            time:"2018 - 2019",
        }
    ],
}